module.exports = __webpack_public_path__ + "media/images/gift_plan/bubble-img-otoku-02-336327ef27d4814216a628a152b4cd5e.png";